import React, {useEffect, useRef} from "react";
import {motion} from "framer-motion";
import styles from "../../Parigi.module.css";

const FLIGHT_PATH = "M40,150 Q200,10 360,50";
const FLIGHT_DURATION = 2; // seconds

const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

const FlightAnimation = ({onDone}) => {
    const pathRef = useRef(null);
    const planeRef = useRef(null);
    const onDoneRef = useRef(onDone);

    useEffect(() => {
        onDoneRef.current = onDone;
    }, [onDone]);

    useEffect(() => {
        const path = pathRef.current;
        const plane = planeRef.current;
        if (!path || !plane) return;

        const totalLength = path.getTotalLength();
        const start = performance.now();
        let frameId;

        const tick = (now) => {
            const t = Math.min((now - start) / (FLIGHT_DURATION * 1000), 1);
            const eased = easeInOutQuad(t);
            const point = path.getPointAtLength(eased * totalLength);
            const ahead = path.getPointAtLength(Math.min(eased * totalLength + 1, totalLength));
            const angle = Math.atan2(ahead.y - point.y, ahead.x - point.x) * (180 / Math.PI);
            plane.setAttribute('transform', `translate(${point.x},${point.y}) rotate(${angle})`);

            if (t < 1) {
                frameId = requestAnimationFrame(tick);
            } else {
                onDoneRef.current && onDoneRef.current();
            }
        };

        frameId = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(frameId);
    }, []);

    return (
        <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.5}}
            className={styles.flightWrapper}
        >
            <svg viewBox="0 0 400 200" className={styles.flightSvg} aria-hidden="true">
                <text x="20" y="178" className={styles.mapLabel}>🇮🇹 Italia</text>
                <text x="300" y="30" className={styles.mapLabel}>🇫🇷 Parigi</text>
                <motion.path
                    ref={pathRef}
                    d={FLIGHT_PATH}
                    className={styles.flightTrail}
                    initial={{pathLength: 0}}
                    animate={{pathLength: 1}}
                    transition={{duration: FLIGHT_DURATION, ease: "easeInOut"}}
                />
                <g ref={planeRef}>
                    <text x="0" y="4" textAnchor="middle" className={styles.planeIcon}>✈️</text>
                </g>
            </svg>
        </motion.div>
    );
};

export default FlightAnimation;
